/**
 * Haversine distance in meters between two coordinates.
 * Mirrors the server-side geofence math so the client can decide whether a
 * punch is outside the office area before submitting. Server stays authoritative.
 */
export const distanceInMeters = (lat1, lng1, lat2, lng2) => {
  const earthRadius = 6371000
  const toRad = deg => (deg * Math.PI) / 180

  const latDelta = toRad(lat2 - lat1)
  const lngDelta = toRad(lng2 - lng1)

  const a =
    Math.sin(latDelta / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(lngDelta / 2) ** 2

  return earthRadius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}
